export default __webpack_public_path__ + "static/media/greeting25.3983405e.png";